// Secção ainda por construir: diz em que marco chega e o que vai ter.
import { useTranslation } from "@ecliptica/i18n";
import { EmptyState, PageHeader } from "@ecliptica/ui";
import { Hourglass } from "lucide-react";
import type { SectionKey } from "../../features/nav/sections";

export function SoonPage({ section, milestone }: { section: SectionKey; milestone: string }) {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader title={t(`nav.${section}`)} description={t(`sections.${section}`)} />
      <EmptyState icon={<Hourglass />} title={t("soon.title")}>
        {t("soon.milestone", { milestone })}
      </EmptyState>
    </>
  );
}
